import { createSelector } from 'reselect';
import { RootState } from '..';

export const selectUser = (state: RootState) => {
  return state.user;
};

export const selectUserId = createSelector(selectUser, (user) => {
  return user._id;
});

export const selectAuth = createSelector(selectUser, (user) => {
  return user.auth;
});
